import {  Numbers, UPDATE_NUMBERS } from "./types"

export const updateNumbers = (numbers: Numbers) => {
    return {
      type: UPDATE_NUMBERS,
      payload: numbers
    }
}
  